import {
  Flex,
  HelpIcon,
  SPACING_24,
  SpacingVertical,
  Switcher,
  TEXT_VARIANT_BOLD,
  Text
} from 'mailup-web-components'
import { taskConditionsState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'
import ApplyConditionsEventComponent from './contitions/ApplyConditionsEventComponent'
import ApplyConditionsFieldComponent from './contitions/ApplyConditionsFieldComponent'
import ConditionAnagFilterFalse from './contitions/ConditionAnagFilterFalse'
import ConditionAnagFilterTrue from './contitions/ConditionAnagFilterTrue'
import ConditionsOtherFilterFalse from './contitions/ConditionsOtherFilterFalse'
import ConditionsOtherFilterTrue from './contitions/ConditionsOtherFilterTrue'

const BoxSelectRecipientsConditions = () => {
  const intl = useIntl()
  const [{ ApplyConditionsRule }, setTaskConditionsState] =
    useRecoilState(taskConditionsState)

  const onChangeApplyConditionsRule = (value) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      ApplyConditionsRule: value,
      isDirty: true
    }))
  }

  return (
    <>
      <Flex alignItems='baseline' height='24px'>
        <Switcher
          label={intl.formatMessage({
            id: 'Load.Task.ConditionsRecipientsFirstTitle'
          })}
          options={[
            {
              label: intl.formatMessage({
                id: 'Load.Task.ConditionsRecipientsSwitchAll'
              }),
              value: 'AND'
            },
            {
              label: intl.formatMessage({
                id: 'Load.Task.ConditionsRecipientsSwitchOne'
              }),
              value: 'OR'
            }
          ]}
          value={ApplyConditionsRule}
          data-mu-test='Switcher-ApplyConditionsRule'
          onChange={onChangeApplyConditionsRule}
        />
        <Text variant={TEXT_VARIANT_BOLD} htmlElement='span'>
          {' '}
          {intl.formatMessage({
            id: 'Load.Task.ConditionsRecipientsLastTitle'
          })}{' '}
        </Text>
        <HelpIcon
          text={intl.formatMessage(
            { id: 'Load.TriggersDetail.TooltipIncludeOnlyRecepients' },
            {
              linebreak: <br />
            }
          )}
        />
      </Flex>
      <SpacingVertical variant={SPACING_24} />
      <Flex flexDirection='column' rowGap='24px'>
        <ApplyConditionsEventComponent />
        <ApplyConditionsFieldComponent />
        <ConditionAnagFilterTrue />
        <ConditionAnagFilterFalse />
        <ConditionsOtherFilterTrue />
        <ConditionsOtherFilterFalse />
      </Flex>
    </>
  )
}

export default BoxSelectRecipientsConditions
